import React, { useCallback } from 'react'

import { useNavigate } from '@lib/react-router-dom'

import { SignupWarningMessages } from '@pages/Signup/Components/SignupWarningMessages'
import { CompanyDetailsTemplate } from '@pages/Signup/Pages/CompanyDetails/CompanyDetailsTemplate'

import { useSessionLanguage } from '@context/SessionSettingsContext'
import { useSignup } from '@context/SignupContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { useFetchOne } from '@hooks/useFetch'
import { useFetchRegulators } from '@hooks/useFetchRegulators'

import { Loading } from '@shared/components/Loading/Loading'

import { CompanyDetailsStep2Form, CompanyDetailsStep2FormValues } from './CompanyDetailsStep2Form'

interface OuterProps {
  onSubmit(values: CompanyDetailsStep2FormValues): void
}

export const CompanyDetailsStep2Page: React.FC<OuterProps> = (props) => {
  const { onSubmit } = props
  const { signupData } = useSignup()
  const apiClient = useApiClient(ClientApiClient)

  const locale = useSessionLanguage()
  const navigate = useNavigate()

  const companyLegalBasesCallback = useCallback(() => {
    return apiClient.getLegalBases(locale)
  }, [apiClient, locale])

  const ownershipStructuresCallback = useCallback(() => {
    return apiClient.getOwnershipStructures(locale)
  }, [apiClient, locale])

  const { data: ownershipStructures = [] } = useFetchOne(ownershipStructuresCallback)
  const { data: legalBases = [] } = useFetchOne(companyLegalBasesCallback)
  const { data: regulators = [], isLoading } = useFetchRegulators()

  return (
    <CompanyDetailsTemplate
      lead={signupData.lead}
      step={2}
      totalSteps={signupData.totalSteps.companyDetails}
      goBack={() => navigate('/sign-up/company-details/basic')}
    >
      <SignupWarningMessages leadTypeId={signupData.lead?.type?.id} />
      <Loading isLoading={isLoading}>
        {regulators && (
          <CompanyDetailsStep2Form
            initialValues={signupData.corporateValues}
            legalBases={legalBases}
            ownershipStructures={ownershipStructures}
            regulators={regulators}
            onSubmit={onSubmit}
          />
        )}
      </Loading>
    </CompanyDetailsTemplate>
  )
}
